/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BillingInfo} from '../models/BillingInfo';
import type {Error} from '../models/Error';

export interface SetLicenseBilling$Request {
    licenseId: number;
    billingInfo: BillingInfo;
}

export interface SetLicenseBilling$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const setLicenseBillingRequest = createAction<PayloadData<void, SetLicenseBilling$Request>>('SET_LICENSE_BILLING__SET_LICENSE_BILLING__REQUEST');
export const setLicenseBillingSuccess = createAction<PayloadData<void, SetLicenseBilling$Request>>('SET_LICENSE_BILLING__SET_LICENSE_BILLING__SUCCESS');
export const setLicenseBillingFailure = createAction<PayloadData<Error, SetLicenseBilling$Request, true>>('SET_LICENSE_BILLING__SET_LICENSE_BILLING__FAILURE');

export const setLicenseBillingActions = [
    setLicenseBillingRequest,
    setLicenseBillingSuccess,
    setLicenseBillingFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {BillingInfo} meta.billingInfo
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const setLicenseBilling = (meta: SetLicenseBilling$Request, config?: SetLicenseBilling$Config) => {
    return {
        CALL_API: {
            types: setLicenseBillingActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/licenses/${meta.licenseId}/billing`,
            TRANSPORT_REQUEST_BODY: meta.billingInfo,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

